class StickyBag extends HTMLElement {
  constructor() {
    super();

    this.STICKY_CLASS = "sticky-bag--active"

    this.addObserver();
  }

  addObserver() {
    const addToBag = document.querySelector(".product-form__button");
    const options = { root: null, rootMargin: "-10% 0px 0px 0px", threshold: 0 };

    this.observer = new IntersectionObserver(this.toggleDisplay.bind(this), options);
    this.observer.observe(addToBag);
  }

  toggleDisplay(entries) {
    entries.forEach(entry => {
      if(!entry.isIntersecting) {
        this.classList.add(this.STICKY_CLASS)
        document.body.classList.add(this.STICKY_CLASS)
      } else {
        this.classList.remove(this.STICKY_CLASS)
        document.body.classList.remove(this.STICKY_CLASS)
      }
    });
  }
}

customElements.define("sticky-bag", StickyBag);